import { ComponentProps } from 'react'

type DivProps = ComponentProps<'div'>

type Props = {
  withPadding?: boolean
} & DivProps

const Paper = ({ withPadding = false, className, ...props }: Props) => {
  return (
    <div
      className={`border border-light_gray_3 rounded-[16px] ${withPadding && 'p-[16px]'} ${className}`}
      {...props}
    />
  )
}

export default Paper
